import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const GWI_FACILITY_LOCATION_TYPE = 4;
const locationsAdapter = getAdapter();

const locationsSlice = createSlice({
  name: 'locations',
  initialState: locationsAdapter.getInitialState(),
  reducers: {
    setLocations: (state, { payload: { locations } }) => {
      locationsAdapter.setAll(state, locations);
    },
  },
});

const selectors = locationsAdapter.getSelectors(({ locations }) => locations);

export const getLocationsIncludingDeleted = (state) => selectors.selectAll(state);

export const getLocations = (state) => getLocationsIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const getGwiFacilityLocations = (state) => getLocations(state).filter(({type}) => type === GWI_FACILITY_LOCATION_TYPE);

export const {
  setLocations,
} = locationsSlice.actions;

export default locationsSlice.reducer;
